import React from 'react';

import { CurrentBookingContext } from '../contexts/current-booking.context';

export function CurrentBookingContextProvider({
  children,
  bookingId,
  hotelReferenceId,
}: {
  children: React.ReactNode;
  bookingId: string;
  hotelReferenceId: string;
}) {
  return (
    <CurrentBookingContext.Provider value={{ bookingId, hotelReferenceId }}>
      {children}
    </CurrentBookingContext.Provider>
  );
}
